import { render, staticRenderFns } from "./WidgetContainer.vue?vue&type=template&id=a4b8d5f2&scoped=true&"
import script from "./WidgetContainer.vue?vue&type=script&lang=js&"
export * from "./WidgetContainer.vue?vue&type=script&lang=js&"
import style0 from "./WidgetContainer.vue?vue&type=style&index=0&id=a4b8d5f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b8d5f2",
  null
  
)

export default component.exports